import { bindingMode, autoinject } from "aurelia-framework";
import { bindable } from "aurelia-typed-observable-plugin";
import { FormControl } from "components/form-controls/form-control";
import { Position } from "enums/position";
import { ViewModeHelper } from "helpers/view-mode-helper";

@autoinject()
export class Checkbox2Fc extends FormControl {

    @bindable({ defaultBindingMode: bindingMode.twoWay })
    public checked: any;
    
    @bindable public model: any;
    @bindable public matcher: any;

    @bindable.string
    public labelPosition: Position = Position.Top;

    constructor(element: Element, private readonly viewModeHelper: ViewModeHelper) {
        super(element);
    }

    public attached(): void {
         if (this.viewModeHelper.getIsMobileMode()) {
             this.labelPosition =  Position.Top;
         }
    }
}
